// extracted by mini-css-extract-plugin
export default {"components_flex":"RecipeEntry_components_flex__fj16o","components_column":"RecipeEntry_components_column__Gs0EE"};